let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("66VwL")).then(() => parcelRequire('cAlmw'));